import { FC } from "react";
import "../../components/OrderTracking/styles.scss";
import RefundManagementComp from "../../components/RefundManagementComp";

const RefundManagementPage: FC = () => {
  return <RefundManagementComp />;
};

export default RefundManagementPage;
